module.exports = "/_next/static/resources/photo-2-7a1857ed5d88ae451ce4afb972ce1792.webp";